export enum NewsCategory {
    Advokat = 'advokat',
    Meddommer = 'meddommer',
    Selvprosederende = 'selvprosederende',
    Statement = 'statement',
    News = 'news',
}
